import { render } from "./PackageGroupCard.vue?vue&type=template&id=00ce144b&scoped=true"
import script from "./PackageGroupCard.vue?vue&type=script&lang=js"
export * from "./PackageGroupCard.vue?vue&type=script&lang=js"

import "./PackageGroupCard.vue?vue&type=style&index=0&id=00ce144b&scoped=true&lang=css"
/* custom blocks */
import block0 from "@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/package_group_card.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fcustomer%2Fquery%2Fbasic_containers%2Fshow_container%2Ftabs%2Fpallets%2FPackageGroupCard.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/package_group.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fcustomer%2Fquery%2Fbasic_containers%2Fshow_container%2Ftabs%2Fpallets%2FPackageGroupCard.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ce144b"]])

export default __exports__